import axios from './HTTP'

export default {
  create (params, callback, errorCallback) {
    axios
      .post(`/api/clients.json`, params)
      .then(response => {
          callback(response.data)
      })
      .catch( error => {
        errorCallback(error)
      })
  },

  getAll (userId, callback) {
    return axios
      .get('/api/clients.json', { params: { user_id: userId } })
      .then(response => ( callback(response.data) ))
  },

  get (clientId, callback) {
    axios
      .get(`/api/clients/${ clientId }.json`)
      .then(response => ( callback(response.data) ))
  },

  deactivate (clientId, callback, errorCallback) {
    axios
      .get(`/api/clients/${ clientId }/deactivate.json`)
      .then(response => ( callback(response.data) ))
      .catch(err => ( errorCallback(err) ))
  },

  reactivate (clientId, callback, errorCallback) {
    axios
      .get(`/api/clients/${ clientId }/reactivate.json`)
      .then(response => ( callback(response.data) ))
      .catch(err => ( errorCallback(err) ))
  },

  delete (clientId, callback, errorCallback) {
    axios
      .delete(`/api/clients/${ clientId }.json`)
      .then(response => ( callback(response.data) ))
      .catch(err => ( errorCallback(err) ))
  },

  update (idAndFields, callback, errorCallback) {
    axios
      .patch(`/api/clients/${ idAndFields.id }.json`, idAndFields)
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  addLocation (params, callback, errorCallback) {
    axios
      .post(`/api/client_locations.json`, {
        client_location: {
          user_id: params.clientId,
          worksite_id: params.locationId
        }
      })
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  addAdminLocation (params, callback, errorCallback) {
    console.log('aparams; ', params)
    axios
      .post(`/api/client_admin_locations.json`, {
        client_location: {
          user_id: params.clientId,
          worksite_id: params.locationId
        }
      })
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  deleteLocation (params, callback, errorCallback) {
    axios
      .delete(`/api/client_locations.json`, {
        params: {
          user_id: params.clientId,
          worksite_id: params.locationId
        }
      })
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

  deleteAdminLocation (params, callback, errorCallback) {
    axios
      .delete(`/api/client_admin_locations.json`, {
        params: {
          user_id: params.clientId,
          worksite_id: params.locationId
        }
      })
      .then(response => {
        callback(response.data)
      })
      .catch(error => {
        errorCallback(error)
      })
  },

}
